import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/fr';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

moment.locale('fr');
const localizer = momentLocalizer(moment);
Modal.setAppElement('#root');

function DisponibilitesCalendar() {
  const [events, setEvents] = useState([]);
  const [services, setServices] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentView, setCurrentView] = useState(Views.MONTH);
  const [weeksToShow, setWeeksToShow] = useState(12);
  const [cancellationReason, setCancellationReason] = useState('');
  const [specialities, setSpecialities] = useState([]);
  const [selectedSpeciality, setSelectedSpeciality] = useState('');
  const navigate = useNavigate();
  const [editForm, setEditForm] = useState({
    start_time: '',
    end_time: '',
    mode: '',
    service_id: '',
    date: '',
    isRecurring: false,
    recurrenceEndDate: ''
  });
  const [showRecurrenceChoice, setShowRecurrenceChoice] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [rescheduleForm, setRescheduleForm] = useState([
    { proposed_date: '', start_time: '', end_time: '' },
    { proposed_date: '', start_time: '', end_time: '' },
    { proposed_date: '', start_time: '', end_time: '' }
  ]);
  const [rescheduleProposals, setRescheduleProposals] = useState([]);

  const customModalStyles = {
    content: {
      width: '360px',
      maxWidth: '90%',
      margin: 'auto',
      padding: '1.2rem',
      borderRadius: '12px',
      boxShadow: '0 6px 24px rgba(0, 0, 0, 0.2)',
      backgroundColor: '#ffffff',
      fontFamily: 'Arial, sans-serif',
      border: '1px solid #ddd',
      inset: '50% auto auto 50%',
      transform: 'translate(-50%, -50%)'
    }
  };

  const fetchEvents = async () => {
    try {
      const email = localStorage.getItem("user_email");
      const userRes = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${email}`);
      const user = await userRes.json();
      const userId = user.user_id;
  
      const [availRes, allServicesRes, apptRes, specialityRes] = await Promise.all([
        fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${userId}/weekly-availabilities?weeks=${weeksToShow}`),
        fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/services`), // 🔥 Tous les services
        fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/appointments/professional/${userId}`),
        fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${userId}/specialities`)
      ]);
  
      const [availabilities, serviceList, apptData, specialityList] = await Promise.all([
        availRes.json(),
        allServicesRes.json(),
        apptRes.json(),
        specialityRes.json()
      ]);
  
      setServices(serviceList);
      setSpecialities(specialityList)

      const appointments = apptData.appointments;
    console.log("📅 Appointments récupérés :", appointments);
    console.log("🔎 sample cancelled:", appointments.find(x => x.status === 'cancelled'));
console.log("🔎 sample scheduled:", appointments.find(x => x.status === 'scheduled'));

    // 🔍 Debug des statuts
    appointments.forEach(a => {
  console.log("🔍 Appointment ID:", a.id, "| Status:", a.status);
    });
      setServices(serviceList);
      const availabilityEvents = availabilities.map((a) => {
        const start = new Date(`${a.date}T${a.start_time}`);
        const end = new Date(`${a.date}T${a.end_time}`);
        const service = serviceList.find(s => s.service_id === a.service_id);

        return {
          id: a.id,
          type: 'availability',
          service_id: a.service_id,
          title: service?.name || "Service",
          start,
          end,
          mode: a.mode,
          date: a.date
        };
      });

      const appointmentEvents = (appointments || []).map(a => ({
        id: a.id,
        type: 'appointment',
        title: `🧑 ${a.patient_name ?? 'Usager'} - ${a.service_name || 'Rendez-vous'}`,
        start: moment(a.start, ['YYYY-MM-DD HH:mm:ss', moment.ISO_8601], true).toDate(),
        end:   moment(a.end,   ['YYYY-MM-DD HH:mm:ss', moment.ISO_8601], true).toDate(),
        patient_name: a.patient_name,
        service_name: a.service_name,
        notes: a.notes,
        mode: a.mode,
        status: a.status,
        professional_name: a.professional_name,
        patient_email: a.patient_email,
        isConfirmed: a.is_confirmed_by_professional === true
      })).filter(e => !isNaN(e.start) && !isNaN(e.end));
      console.log("📦 Événements envoyés au calendrier :", [
        ...availabilityEvents,
        ...appointmentEvents,
      ]);

      setEvents([...availabilityEvents, ...appointmentEvents]);
    } catch (err) {
      console.error("Erreur chargement calendrier :", err);
    }
  };
  const handleSpecialityChange = (e) => {
    const specialityId = e.target.value;
    setSelectedSpeciality(specialityId);
  
    // Trouver les services de cette spécialité parmi tous les services
    const servicesForThisSpeciality = services.filter(
      (s) => s.speciality_id === specialityId
    );
  
    // Sélectionner automatiquement le premier service de la spécialité si dispo
    setEditForm({
      ...editForm,
      service_id: servicesForThisSpeciality[0]?.service_id || ''
    });
  };
  useEffect(() => {
    fetchEvents();
  }, [weeksToShow]);
  const handleSelectEvent = (event) => {
    console.log("🖱️ Événement sélectionné :", event);
    setSelectedEvent(event);

    const relatedService = services.find(
      (s) => s.service_id === event.service_id
    );
    const relatedSpecialityId = relatedService?.speciality_id || '';
    
    setSelectedSpeciality(relatedSpecialityId);
    if (event.type === 'availability') {
      setEditForm({
        start_time: moment(event.start).format('HH:mm'),
        end_time: moment(event.end).format('HH:mm'),
        mode: event.mode || 'in_person',
        service_id: event.service_id || '',
        date: event.date || ''
      });
    } else {
      setEditForm({
        start_time: '',
        end_time: '',
        mode: '',
        service_id: '',
        date: ''
      });
    }

    setModalOpen(true);
  };
  const handleSelectSlot = (slotInfo) => {
    const selectedDate = moment(slotInfo.start).format('YYYY-MM-DD');
    console.log('📅 Date sélectionnée pour ajout :', selectedDate);
  
    setEditForm({
      start_time: '',
      end_time: '',
      mode: 'in_person',
      service_id: services[0]?.service_id || '',
      date: selectedDate
    });
    if (specialities.length > 0) {
      setSelectedSpeciality(specialities[0].speciality_id);
    } else {
      setSelectedSpeciality('');
    }
    setSelectedEvent(null); // pas d'événement sélectionné, c'est une création
    setModalOpen(true);
  };
  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditForm({ ...editForm, [name]: type === 'checkbox' ? checked : value });
  };

  const handleProposalChange = (index, field, value) => {
    const updated = [...rescheduleForm];
    updated[index][field] = value;
    setRescheduleForm(updated);
  };

  const executeUpdate = async (recurrence) => {
    try {
      const email = localStorage.getItem("user_email");
      const userRes = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${email}`);
      const user = await userRes.json();
      const professionalId = user.user_id;
      const endpoint = `https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${professionalId}/weekly-availabilities/${selectedEvent.id}`;

      const bodyToSend = {
        ...editForm,
        recurrence,
        start_time: editForm.start_time.trim(),
        end_time: editForm.end_time.trim()
      };

      if (!recurrence) bodyToSend.date = selectedEvent.date;

      const res = await fetch(endpoint, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyToSend)
      });

      if (!res.ok) throw new Error("Erreur mise à jour");
      setModalOpen(false);
      await fetchEvents();
    } catch (err) {
      console.error("Erreur mise à jour:", err);
    }
  };

  const handleUpdate = () => {
    setPendingAction('update');
    setShowRecurrenceChoice(true);
  };
  
  const handleCreateAvailability = async () => {
    try {
      const { start_time, end_time, date, mode, service_id, isRecurring, recurrenceEndDate } = editForm;
  
      if (!start_time || !end_time || !date || !mode || !service_id) {
        alert("❌ Merci de remplir tous les champs.");
        return;
      }
  
      const dayOfWeek = moment(date).isoWeekday();
      const email = localStorage.getItem("user_email");
      const userRes = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${email}`);
      const user = await userRes.json();
      const professionalId = user.user_id;
  
      const endpoint = `https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${professionalId}/weekly-availabilities`;
  
      const bodyToSend = {
        day_of_week: dayOfWeek,
        start_time: start_time.trim(),
        end_time: end_time.trim(),
        mode,
        service_id,
        valid_from: date,
        valid_to: isRecurring && recurrenceEndDate ? recurrenceEndDate : date
      };
  
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyToSend)
      });
  
      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`Erreur : ${errorText}`);
      }
  
      alert("✅ Disponibilité ajoutée !");
      setModalOpen(false);
      await fetchEvents();
    } catch (err) {
      console.error("Erreur ajout :", err);
      alert("❌ Échec : " + err.message);
    }
  };
  const executeDelete = async (recurrence) => {
    try {
      const email = localStorage.getItem("user_email");
      const userRes = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${email}`);
      const user = await userRes.json();
      const professionalId = user.user_id;
      const endpoint = `https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${professionalId}/weekly-availabilities/${selectedEvent.id}`;

      const bodyToSend = { recurrence };
      if (!recurrence) bodyToSend.date = selectedEvent.date;

      const res = await fetch(endpoint, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyToSend)
      });

      if (!res.ok) throw new Error("Erreur suppression");
      setModalOpen(false);
      await fetchEvents();
    } catch (err) {
      console.error("Erreur suppression:", err);
    }
  };

  const handleDelete = () => {
    setPendingAction('delete');
    setShowRecurrenceChoice(true);
  };

  const handleCancelAppointment = () => {
    setShowRescheduleModal(true);
  };

  const submitRescheduleProposals = async () => {
    try {
      const email = localStorage.getItem("user_email");
      const userRes = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${email}`);
      const professional = await userRes.json();
  
      const appointmentId = selectedEvent.id;
      const professionalName = selectedEvent.professional_name || `${professional.first_name} ${professional.last_name}`;
      const patientEmail = selectedEvent.patient_email || selectedEvent.email;
      const patientName = selectedEvent.patient_name;
      const appointmentDate = moment(selectedEvent.start).format("YYYY-MM-DD");
      const appointmentTime = moment(selectedEvent.start).format("HH:mm");
  
      const bodyToSend = {
        patientEmail,
        patientName,
        professionalName,
        appointmentDate,
        appointmentTime,
        proposals: rescheduleForm,
        professionalId: professional.user_id,
        cancellationReason
      };
      if (!cancellationReason.trim()) {
          alert ("veuillez renseigner la raison de l'annulation.");
          return;
      }
      const res = await fetch(
        `https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/appointments/${appointmentId}/send-cancellation-email`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(bodyToSend)
        }
      );
      
      const responseText = await res.text();
      console.log("📩 Réponse du backend:", responseText);
  
      if (!res.ok) throw new Error("Erreur lors de l'envoi du courriel");
  
      alert("✅ Courriel d'annulation et propositions envoyé !");
      setShowRescheduleModal(false);
      setModalOpen(false);
      await fetchEvents();
    } catch (err) {
      console.error("Erreur :", err);
      alert("❌ Échec de l’envoi");
    }
  };

  const handleRescheduleChange = (index, field, value) => {
    const newForm = [...rescheduleForm];
    newForm[index][field] = value;
    setRescheduleForm(newForm);
  };

  const handleRecurrenceChoice = (recurrence) => {
    setShowRecurrenceChoice(false);
    if (pendingAction === 'update') executeUpdate(recurrence);
    else if (pendingAction === 'delete') executeDelete(recurrence);
  };
  const handleConfirmAppointment = async () => {
    try {
      const res = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/appointments/${selectedEvent.id}/confirm`, {
        method: 'PUT',
      });
  
      if (!res.ok) throw new Error("Erreur confirmation");
  
      // ✅ Met à jour l’état local
      setSelectedEvent(prev => ({
        ...prev,
        isConfirmed: true,
      }));
  
      alert("✅ Rendez-vous confirmé !");
      
      // 🔄 Recharge tous les événements pour refléter le changement dans le calendrier
      await fetchEvents();
  
      // ✅ UX : fermer la modale
      setModalOpen(false);
    } catch (err) {
      console.error("Erreur confirmation rendez-vous:", err);
      alert("❌ Une erreur est survenue lors de la confirmation.");
    }
  };
  const eventStyleGetter = (event) => {
    let style = {
      borderRadius: '6px',
      color: '#000',
      border: '1px solid #888',
      padding: '4px'
    };
  
    if (event.type === 'availability') {
      style.backgroundColor = '#d0e8ff'; // bleu clair
    } else if (event.type === 'appointment') {
      if (event.status === 'cancelled') {
        style.backgroundColor = '#cccccc'; // gris
        style.textDecoration = 'line-through';
      } else if (event.isConfirmed) {
        style.backgroundColor = '#c8e6c9'; // vert clair si confirmé
      } else {
        style.backgroundColor = '#ffd6d6'; // rouge clair si pas encore confirmé
      }
    } else if (event.type === 'proposal') {
      style.backgroundColor = '#e1bee7'; // violet clair
      style.fontStyle = 'italic';
    }
  
    return { style };
  };

  useEffect(() => {
    const fetchRescheduleProposals = async () => {
      if (
        (selectedEvent?.type === 'appointment' && selectedEvent?.status === 'cancelled') ||
        (selectedEvent?.type === 'proposal' && selectedEvent?.appointment_id)
      ) {
        const appointmentId = selectedEvent.type === 'proposal'
          ? selectedEvent.appointment_id
          : selectedEvent.id;
        console.log("📥 ID utilisé pour récupérer les propositions:", appointmentId);
        try {
          const res = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/appointments/${appointmentId}/reschedule-proposals`);
          const data = await res.json();
          console.log("Propositions récupérées :", data.proposals);
          setRescheduleProposals(data.proposals || []);
        } catch (err) {
          console.error("Erreur récupération propositions :", err);
          setRescheduleProposals([]);
        }
      } else {
        setRescheduleProposals([]);
      }
    };

    fetchRescheduleProposals();
  }, [selectedEvent]);

  console.log("🛠️ Services :", services);
console.log("🔍 Selected Speciality :", selectedSpeciality);
  return (
    <div style={{ padding: '2rem' }}>

      <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <button
          onClick={() => navigate('/professional/add-availability')}
          style={{
            backgroundColor: '#1e88e5',
            color: 'white',
            border: 'none',
            padding: '10px 15px',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Ajouter une disponibilité
        </button>
  
        <label htmlFor="weeksToShow">Afficher les créneaux pour :</label>
        <select
          id="weeksToShow"
          value={weeksToShow}
          onChange={e => setWeeksToShow(Number(e.target.value))}
          style={{ padding: '6px' }}
        >
          <option value={4}>4 semaines</option>
          <option value={12}>12 semaines</option>
          <option value={26}>6 mois</option>
          <option value={52}>1 an</option>
          <option value={104}>2 ans</option>
        </select>
      </div>

      <Calendar
  localizer={localizer}
  date={currentDate}
  onNavigate={date => setCurrentDate(date)}
  events={events}
  startAccessor="start"
  endAccessor="end"
  style={{ height: 700, marginTop: '1rem' }}
  defaultView={Views.MONTH}
  views={[Views.MONTH, Views.WEEK, Views.DAY]}
  view={currentView}
  onView={view => setCurrentView(view)}
  onSelectEvent={handleSelectEvent}
  onSelectSlot={handleSelectSlot} // ⬅️ Ajouté ici
  selectable
  popup
  eventPropGetter={eventStyleGetter}
/>

      <Modal isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} style={customModalStyles}>
      {(!selectedEvent || selectedEvent.type === 'availability') && (
    <>
      <h3>{selectedEvent ? "Modifier la disponibilité" : "Ajouter une disponibilité"}</h3>

      <label>Jour :</label>
      <input type="date" name="date" value={editForm.date} onChange={handleEditChange} /><br />

      <label>Début :</label>
      <input type="time" name="start_time" value={editForm.start_time} onChange={handleEditChange} /><br />

      <label>Fin :</label>
      <input type="time" name="end_time" value={editForm.end_time} onChange={handleEditChange} /><br />

      <label>Mode :</label>
      <select name="mode" value={editForm.mode} onChange={handleEditChange}>
        <option value="in_person">À domicile</option>
        <option value="virtual">En ligne</option>
      </select><br />

      <label>Spécialité :</label>
      <select value={selectedSpeciality} onChange={handleSpecialityChange}>
        {specialities.map(s => (
          <option key={s.speciality_id} value={s.speciality_id}>
            {s.name}
          </option>
        ))}
      </select><br />

      <label>Service :</label>
      <select
        name="service_id"
        value={editForm.service_id}
        onChange={handleEditChange}
      >
        {services.map(s => (
          <option key={s.service_id} value={s.service_id}>
            {s.name}
          </option>
        ))}
      </select><br />

      {!selectedEvent && (
  <>
    <label>
      <input
        type="checkbox"
        name="isRecurring"
        checked={editForm.isRecurring || false}
        onChange={handleEditChange}
      />
      Répéter chaque semaine
    </label><br />

    {editForm.isRecurring && (
      <>
        <label>Jusqu’au :</label>
        <input
          type="date"
          name="recurrenceEndDate"
          value={editForm.recurrenceEndDate || ''}
          onChange={handleEditChange}
        /><br />
      </>
    )}
  </>
)}

      {selectedEvent ? (
        <>
          <button onClick={handleUpdate}>💾 Enregistrer</button>{' '}
          <button onClick={handleDelete} style={{ color: 'red' }}>🗑 Supprimer</button>{' '}
        </>
      ) : (
        <button onClick={handleCreateAvailability}>➕ Ajouter</button>
      )}
    </>
  )}

        {selectedEvent?.type === 'appointment' && (
          <div>
            <p><strong>Usager :</strong> {selectedEvent.patient_name}</p>
            <p><strong>Service :</strong> {selectedEvent.service_name}</p>
            <p><strong>Date :</strong> {moment(selectedEvent.start).format('dddd D MMMM YYYY')}</p>
            <p><strong>Heure :</strong> {moment(selectedEvent.start).format('HH:mm')} - {moment(selectedEvent.end).format('HH:mm')}</p>
            <p><strong>Mode :</strong> {selectedEvent.mode === 'virtual' ? 'En ligne' : 'À domicile'}</p>
            {selectedEvent.notes && (
              <p><strong>Notes :</strong> {selectedEvent.notes}</p>
            )}
            <p>
              <strong>Statut :</strong>{" "}
              {selectedEvent.status === "scheduled" && selectedEvent.isConfirmed
                ? "confirmé"
                : selectedEvent.status}
            </p>

            {selectedEvent.status !== 'cancelled' && (
              <button onClick={handleCancelAppointment} style={{ color: 'orange' }}>
                ❌ Annuler & proposer 3 créneaux
              </button>
            )}
 {selectedEvent.status === 'scheduled' && !selectedEvent.isConfirmed && (
  <button onClick={handleConfirmAppointment} style={{ backgroundColor: '#4caf50', color: 'white', marginTop: '1rem' }}>
    ✅ Confirmer ce rendez-vous
  </button>
  )}
  {selectedEvent.status === 'scheduled' && selectedEvent.isConfirmed && (
    <div style={{ color: 'green', fontWeight: 'bold', marginTop: '1rem' }}>
      ✅ Rendez-vous confirmé
    </div>
)}

            {(selectedEvent?.status === 'cancelled' || selectedEvent?.type === 'proposal') && rescheduleProposals.length > 0 && (
              <div style={{ marginTop: '1rem' }}>
                <p><strong>Propositions envoyées :</strong></p>
                <ul>
                  {rescheduleProposals.map((p, i) => (
                    <li key={p.proposal_id}>
                      📅 {moment(p.proposed_date).format('DD/MM/YYYY')} – 🕒 {p.start_time} → {p.end_time}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}

        <button onClick={() => setModalOpen(false)}>Annuler</button>
      </Modal>

      <Modal isOpen={showRecurrenceChoice} onRequestClose={() => setShowRecurrenceChoice(false)} style={customModalStyles}>
        <h4>Souhaitez-vous appliquer cette action à toutes les occurrences ?</h4>
        <button onClick={() => handleRecurrenceChoice(true)}>Oui</button>
        <button onClick={() => handleRecurrenceChoice(false)}>Non, uniquement cette date</button>
      </Modal>

      <Modal isOpen={showRescheduleModal} onRequestClose={() => setShowRescheduleModal(false)} style={customModalStyles}>
  <h4>Proposer 3 nouveaux créneaux</h4>

  <div style={{ marginBottom: '1rem' }}>
    <label>Raison de l’annulation :</label><br />
    <textarea
      value={cancellationReason}
      onChange={e => setCancellationReason(e.target.value)}
      rows={3}
      style={{ width: '100%' }}
      placeholder="Exemple : imprévu personnel, problème de santé, déplacement..."
      required
    />
  </div>

  {rescheduleForm.map((slot, i) => (
    <div key={i}>
      <label>Jour :</label>
      <input type="date" value={slot.proposed_date} onChange={e => handleRescheduleChange(i, 'proposed_date', e.target.value)} /><br />
      <label>Début :</label>
      <input type="time" value={slot.start_time} onChange={e => handleRescheduleChange(i, 'start_time', e.target.value)} /><br />
      <label>Fin :</label>
      <input type="time" value={slot.end_time} onChange={e => handleRescheduleChange(i, 'end_time', e.target.value)} /><br /><br />
    </div>
  ))}

  <button onClick={submitRescheduleProposals}>📨 Envoyer les propositions</button>{' '}
  <button onClick={() => setShowRescheduleModal(false)}>Annuler</button>
</Modal>
    </div>
  );
}

export default DisponibilitesCalendar;